import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import {
  fetchHomeContent,
  fetchServices,
  fetchCoreValues,
  fetchInsurance,
  fetchConditions,
  fetchBlog,
  fetchLocations,
} from "../../Redux/WebsiteSlice";
import { getImageUrl } from "../../services/api";
import "./Home.scss";
import banner from "../../assets/img/banner home.webp";
import Sec2 from "../../assets/img/sec 2.jpg";
import s1 from "../../assets/img/s1.jpg";
import s2 from "../../assets/img/s2.png";
import s3 from "../../assets/img/s3.png";
import s4 from "../../assets/img/s4.jpg";
import HICAPS from "../../assets/img/HICAPS.webp";
import ExpertDiagnosis from "../../assets/img/Expert Diagnosis.webp";
import TailoredSolutions from "../../assets/img/Tailored Solutions.webp";
import PosturalErgonomicAdvice from "../../assets/img/Postural And Ergonomic Advice.webp";
import WorkersCompensation from "../../assets/img/Workers Compensation.webp";
import HCFPreferredProvider from "../../assets/img/HCF Preferred Provider.webp";
import lower_back from "../../assets/img/reasons-for-lower-back-pain.webp";
import { useBookingModal } from "../../context/BookingModalContext";
import Reveal from "../Shared/Reveal";

const CORE_VALUE_FALLBACKS = [
  ExpertDiagnosis,
  TailoredSolutions,
  PosturalErgonomicAdvice,
  WorkersCompensation,
  HCFPreferredProvider,
];

const SERVICE_FALLBACKS = [s1, s2, s3, s4];

const Home = () => {
  const dispatch = useDispatch();
  const homeContent = useSelector((state) => state.website.homeContent);
  const services = useSelector((state) => state.website.services);
  const coreValues = useSelector((state) => state.website.coreValues);
  const insurance = useSelector((state) => state.website.insurance);
  const conditions = useSelector((state) => state.website.conditions);
  const blog = useSelector((state) => state.website.blog);
  const locations = useSelector((state) => state.website.locations);
  const { openModal } = useBookingModal();
  const location = useLocation();
  const [visibleConditionsCount, setVisibleConditionsCount] = useState(6);
  const [serviceSlide, setServiceSlide] = useState(0);
  const [serviceSlidesPerView, setServiceSlidesPerView] = useState(3);

  useEffect(() => {
    const update = () => {
      if (window.innerWidth < 640) setServiceSlidesPerView(1);
      else if (window.innerWidth < 1024) setServiceSlidesPerView(2);
      else setServiceSlidesPerView(3);
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  useEffect(() => {
    setServiceSlide(0);
  }, [serviceSlidesPerView]);

  useEffect(() => {
    dispatch(fetchHomeContent());
    dispatch(fetchServices());
    dispatch(fetchCoreValues());
    dispatch(fetchInsurance());
    dispatch(fetchConditions());
    dispatch(fetchBlog(3));
    dispatch(fetchLocations());
  }, [dispatch]);

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        scrollToSection(location.state.scrollTo);
      }, 500);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    const handleHashScroll = () => {
      const hash = window.location.hash;
      if (hash) {
        const sectionId = hash.substring(1);
        setTimeout(() => {
          scrollToSection(sectionId);
        }, 300);
      }
    };

    handleHashScroll();
    window.addEventListener("hashchange", handleHashScroll);
    return () => {
      window.removeEventListener("hashchange", handleHashScroll);
    };
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.scrollY - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <div className="main main_home">
        <div className="hero-width0">
          <div id="beforemain_wrap">
            <main id="main-areaarticle">
              <article id="main-area">
                {/* ==================== Hero Section ==================== */}
                <section
                  id="comp_home_hero_2_1"
                  className="compSection compSection_1 comp_home_hero_2 comp_home_hero_2_1 cst_h_hero_2 textcolor__default"
                  data-animate="0"
                  style={{ zIndex: 1 }}
                >
                  <span className="section__bgimage">
                    <img
                      src={
                        homeContent?.hero?.backgroundImage
                          ? getImageUrl(homeContent.hero.backgroundImage)
                          : banner
                      }
                      alt="banner"
                      onError={(e) => {
                        e.target.src = banner;
                      }}
                    />
                  </span>
                  <div className="row to_animate_manual">
                    <div
                      data-speed="0.5"
                      className="data__wrap to_parallax_mousemove"
                    >
                      <h2 className="headline__text h2">
                        {homeContent?.hero?.title || "COMMITTED TO YOUR HEALTH"}
                      </h2>
                      <div className="text__summary">
                        {homeContent?.hero?.description ||
                          "Delivering high quality care that is accessible to everyone."}
                      </div>
                      <button
                        type="button"
                        onClick={() => setTimeout(openModal, 0)}
                        className="site__button site__button_style--solid site__button_shape--default text"
                      >
                        {homeContent?.hero?.buttonText || "Book an Appointment"}
                      </button>
                    </div>
                  </div>
                </section>

                <div className="custom_container">
                  {/* ==================== About Section ==================== */}
                  <section
                    id="comp_two_column_image_text_1"
                    className="compSection compSection_2 comp_two_column_image_text comp_two_column_image_text_1 cst_tcit textcolor__default mb-0 pb-5 pb-md-0"
                    data-animate="1"
                    style={{ zIndex: 1 }}
                  >
                    <div className="row gradient">
                      <div className="columns reverse">
                        <Reveal as="div" direction="left" className="column column1 column__first">
                          <div className="content_wrap">
                            <span className="img_wrap">
                              <img
                                src={
                                  homeContent?.about?.image
                                    ? getImageUrl(homeContent.about.image)
                                    : Sec2
                                }
                                alt=""
                                onError={(e) => {
                                  e.target.src = Sec2;
                                }}
                              />
                            </span>
                          </div>
                        </Reveal>
                        <Reveal as="div" direction="right" delay={0.1} className="column column2 column__last">
                          <div className="standardTextContentBLock layout__default block-first--about">
                            <div className="block block__first">
                              <span className="small__text">
                                {homeContent?.about?.smallText || "ABOUT US"}
                              </span>
                              <h1 className="headline__text h1">
                                {homeContent?.about?.title ||
                                  "About Cornerstone Physiotherapy"}
                              </h1>
                            </div>
                            <div className="block block__last">
                              <div className="text__summary">
                                {homeContent?.about?.description ? (
                                  homeContent.about.description
                                    .split("\n\n")
                                    .map((para, idx) => <p key={idx}>{para}</p>)
                                ) : (
                                  <>
                                    <p>
                                      Cornerstone Physiotherapy's governing
                                      principle is to deliver the highest
                                      quality of care that is accessible to
                                      everyone.
                                    </p>
                                    <p>
                                      Our dedicated team of physiotherapists
                                      achieve this by providing an
                                      individual-specific approach to
                                      healthcare, ensuring each patient receives
                                      the personalised care they deserve.
                                    </p>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </Reveal>
                      </div>
                    </div>
                  </section>

                  {/* ==================== NDIS Section (hidden for future use) ==================== */}
                  <section
                    id="ndis"
                    className="compSection compSection_3 comp_cta comp_cta_1 textcolor__default"
                    data-animate="1"
                    style={{ zIndex: 1 }}
                  >
                    <div className="cta_component cta_item_component_normal cta_item_component_normal_1">
                      <div className="wrap">
                        <div className="image_wrap">
                          <img
                            loading="lazy"
                            src={
                              homeContent?.ndis?.image
                                ? getImageUrl(homeContent.ndis.image)
                                : "images/ndis-left-2.webp"
                            }
                            alt="NDIS"
                            className="small__text"
                            onError={(e) => {
                              e.target.src = "images/ndis-left-2.webp";
                            }}
                          />
                        </div>
                        <div className="content_wrap">
                          <h3>
                            {" "}
                            <span className="small__text ndis-title">
                              {homeContent?.ndis?.title ||
                                "NDIS PHYSIOTHERAPY SERVICES"}
                            </span>
                            {homeContent?.ndis?.description ||
                              "Providing NDIS participants with tailored plans and ongoing support"}
                          </h3>
                          <div className="cta_component_buttons">
                            <div className="button_wrap">
                              <Link
                                className="site__button site__button_style--solid site__button_shape--default site__button--arrow"
                                to={homeContent?.ndis?.buttonLink || "/services"}
                              >
                                <span className="text">
                                  {homeContent?.ndis?.buttonText ||
                                    "Find out more"}
                                </span>
                                <span className="icon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14.679"
                                    height="12.549"
                                    viewBox="0 0 14.679 12.549"
                                  >
                                    <path
                                      d="M1071.608,838.164l-1.02,1.019,4.536,4.535h-11.92v1.441h11.92l-4.536,4.536,1.02,1.019,6.277-6.275Z"
                                      transform="translate(-1063.206 -838.164)"
                                      fill="#fff"
                                    ></path>
                                  </svg>
                                </span>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>

                {/* ==================== Services Section ==================== */}
                {services && services.length > 0 && (
                  <section
                    id="Services"
                    className="compSection services-section"
                    style={{ zIndex: 1 }}
                  >
                    <div className="custom_container">
                      <Reveal as="div" direction="up" className="services-header">
                        <span className="services-label">OUR SERVICES</span>
                        <h2 className="services-title">
                          How We Can <span>Help You</span>
                        </h2>
                      </Reveal>
                      {(() => {
                        const maxSlide = Math.max(0, services.length - serviceSlidesPerView);
                        return (
                          <Reveal as="div" direction="up" delay={0.1} className="services-carousel">
                            <div className="services-carousel__viewport">
                              <div
                                className="services-carousel__track"
                                style={{ transform: `translateX(calc(-${serviceSlide} * ${100 / serviceSlidesPerView}%))` }}
                              >
                                {services.map((service, index) => (
                                  <div key={service._id} className="services-carousel__slide">
                                    <div className="service-card">
                                      <div className="service-card__image">
                                        <img
                                          src={service.image ? getImageUrl(service.image) : SERVICE_FALLBACKS[index % SERVICE_FALLBACKS.length]}
                                          alt={service.title}
                                          onError={(e) => { e.target.src = SERVICE_FALLBACKS[index % SERVICE_FALLBACKS.length]; }}
                                        />
                                      </div>
                                      <div className="service-card__content">
                                        <h4 className="service-card__title">{service.title}</h4>
                                        {service.description && (
                                          <p className="service-card__desc">{service.description}</p>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>

                            {maxSlide > 0 && (
                              <>
                                <button
                                  className="carousel-btn carousel-btn--prev"
                                  onClick={() => setServiceSlide(i => Math.max(0, i - 1))}
                                  disabled={serviceSlide === 0}
                                  aria-label="Previous services"
                                >
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
                                </button>
                                <button
                                  className="carousel-btn carousel-btn--next"
                                  onClick={() => setServiceSlide(i => Math.min(maxSlide, i + 1))}
                                  disabled={serviceSlide === maxSlide}
                                  aria-label="Next services"
                                >
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                                </button>

                                <div className="carousel-dots">
                                  {Array.from({ length: maxSlide + 1 }).map((_, i) => (
                                    <button
                                      key={i}
                                      className={`carousel-dot${serviceSlide === i ? ' carousel-dot--active' : ''}`}
                                      onClick={() => setServiceSlide(i)}
                                      aria-label={`Go to slide ${i + 1}`}
                                    />
                                  ))}
                                </div>
                              </>
                            )}
                          </Reveal>
                        );
                      })()}
                    </div>
                  </section>
                )}

                {/* ==================== Conditions Accordion ==================== */}
                {conditions && conditions.length > 0 && (
                  <div className="custom_container">
                    <section
                      id="comp_two_column_list_accordion_1"
                      className="compSection compSection_8 comp_two_column_list_accordion comp_two_column_list_accordion_1 cts_tcl_accordion textcolor__default services__home"
                      data-animate="1"
                      style={{ zIndex: 1 }}
                    >
                      <div className="row">
                        <Reveal as="div" direction="up" className="conditions-header">
                          <span className="conditions-label">
                            CONDITIONS WE TREAT
                          </span>
                          <h2 className="conditions-title">
                            {homeContent?.conditionsList?.title ||
                              "What We Can Help You With"}
                          </h2>
                        </Reveal>
                        <div className="data__wrap">
                          <Reveal as="div" direction="up" delay={0.1} className="list__data mode--list">
                            {conditions
                              .slice(0, visibleConditionsCount)
                              .map((condition, index) => (
                                <Link
                                  key={condition._id}
                                  to={`/conditions/${condition.slug || condition._id}`}
                                  className="item"
                                >
                                  <span className="item-thumb">
                                    <img
                                      src={
                                        condition.image
                                          ? getImageUrl(condition.image)
                                          : SERVICE_FALLBACKS[
                                              index % SERVICE_FALLBACKS.length
                                            ]
                                      }
                                      alt={condition.title}
                                      onError={(e) => {
                                        e.target.src =
                                          SERVICE_FALLBACKS[
                                            index % SERVICE_FALLBACKS.length
                                          ];
                                      }}
                                    />
                                  </span>
                                  <span className="item-number">
                                    {String(index + 1).padStart(2, "0")}
                                  </span>
                                  <span className="item-body">
                                    <span className="text">
                                      {condition.title}
                                    </span>
                                    {condition.description && (
                                      <span className="item-desc">
                                        {condition.description}
                                      </span>
                                    )}
                                  </span>
                                  <span className="item-arrow" aria-hidden="true">
                                    &rsaquo;
                                  </span>
                                </Link>
                              ))}
                          </Reveal>
                          {visibleConditionsCount < conditions.length ? (
                            <button
                              type="button"
                              className="site__button site__button_style--solid site__button_shape--default site__button--large text btn--loadmore"
                              onClick={() =>
                                setVisibleConditionsCount((c) =>
                                  Math.min(c + 6, conditions.length)
                                )
                              }
                            >
                              Load More
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="site__button site__button_style--solid site__button_shape--default text"
                              onClick={() => setTimeout(openModal, 0)}
                            >
                              {homeContent?.conditionsList?.buttonText ||
                                "Book an appointment"}
                            </button>
                          )}
                        </div>
                      </div>
                    </section>
                  </div>
                )}

                {/* ==================== Our Locations ==================== */}
                {locations && locations.length > 0 && (
                  <div className="custom_container">
                    <section
                      className="compSection comp_locations_grid textcolor__default"
                      data-animate="1"
                      style={{ zIndex: 1 }}
                    >
                      <div className="row">
                        <Reveal as="div" direction="up" className="locations-header">
                          <span className="locations-label">OUR CLINICS</span>
                          <h2 className="locations-title">Our Locations</h2>
                        </Reveal>
                        <Reveal as="div" direction="up" delay={0.1} className="locations-grid">
                          {locations.map((loc) => (
                            <Link
                              key={loc._id}
                              to={`/locations/${loc.slug || loc._id}`}
                              className="location-card"
                            >
                              <div className="location-card__image">
                                <img
                                  src={loc.image ? getImageUrl(loc.image) : Sec2}
                                  alt={loc.name}
                                  onError={(e) => { e.target.src = Sec2; }}
                                />
                              </div>
                              <div className="location-card__content">
                                <h3 className="location-card__title">{loc.name}</h3>
                                {(loc.address?.fullAddress || loc.address?.city) && (
                                  <p className="location-card__address">
                                    {loc.address?.fullAddress ||
                                      `${loc.address?.city}, ${loc.address?.state}`}
                                  </p>
                                )}
                                <span className="location-card__link">View Location &rarr;</span>
                              </div>
                            </Link>
                          ))}
                        </Reveal>
                      </div>
                    </section>
                  </div>
                )}

                {/* ==================== Core Values (hidden) ==================== */}
                <div className="custom_container" style={{ display: 'none' }}>
                  {coreValues && coreValues.length > 0 && (
                    <section
                      id="comp_box_blurbs_1"
                      className="compSection compSection_10 comp_box_blurbs comp_box_blurbs_1 cst_home_bb textcolor__default"
                      data-animate="1"
                      style={{ zIndex: 1, paddingBottom: "0" }}
                    >
                      <div className="row row--heading">
                        <div className="standardTextContentBLock layout__default">
                          <div className="block block__first">
                            <span className="headline__text">
                              Core <span>Values</span>
                            </span>
                            <span className="small__text">
                              In order to achieve the highest quality of care,
                              we live by our core values of….
                            </span>
                          </div>
                          <div className="block block__last">
                            <Link
                              className="site__button site__button_style--solid site__button_shape--default site__button--arrow"
                              to="/contact"
                            >
                              <span className="text">Contact</span>
                              <span className="icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="14.679"
                                  height="12.549"
                                  viewBox="0 0 14.679 12.549"
                                >
                                  <path
                                    d="M1071.608,838.164l-1.02,1.019,4.536,4.535h-11.92v1.441h11.92l-4.536,4.536,1.02,1.019,6.277-6.275Z"
                                    transform="translate(-1063.206 -838.164)"
                                    fill="#fff"
                                  ></path>
                                </svg>
                              </span>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="row row--blurbs uniform">
                        <span className="noise__shadow"></span>
                        <div className="blurbs__wrap">
                          {coreValues.map((value, index) => (
                            <div key={value._id} className="blurb">
                              <img
                                src={
                                  value.image
                                    ? getImageUrl(value.image)
                                    : CORE_VALUE_FALLBACKS[
                                        index % CORE_VALUE_FALLBACKS.length
                                      ]
                                }
                                alt={value.title}
                                onError={(e) => {
                                  e.target.src =
                                    CORE_VALUE_FALLBACKS[
                                      index % CORE_VALUE_FALLBACKS.length
                                    ];
                                }}
                              />
                              <h4>{value.title}</h4>
                            </div>
                          ))}
                        </div>
                      </div>
                    </section>
                  )}
                </div>

                {/* ==================== Blog Section ==================== */}
                {blog && blog.length > 0 && (
                  <section
                    id="blog"
                    className="compSection comp_blog_section textcolor__default"
                    data-animate="1"
                    style={{ zIndex: 1 }}
                  >
                    <div className="custom_container">
                      <span className="noise__shadow"></span>
                      <Reveal as="div" direction="up" className="row row--heading">
                        <div className="standardTextContentBLock layout__center">
                          <div className="block block__first">
                            <span className="small__text">BLOG</span>
                            <h2 className="headline__text h2">
                              Latest News <span>& Articles</span>
                            </h2>
                            <div
                              className="text__summary"
                              style={{
                                maxWidth: "600px",
                                margin: "0 auto",
                                marginTop: "20px",
                              }}
                            >
                              <p>
                                Stay updated with our latest insights, tips, and
                                news about physiotherapy and health.
                              </p>
                            </div>
                          </div>
                          <div className="block block__last"></div>
                        </div>
                      </Reveal>
                      <div className="row row--blogs">
                        <Reveal as="div" direction="up" className="blog__grid">
                          {blog.slice(0, 3).map((post) => (
                            <div key={post._id} className="blog__card">
                              <div className="blog__card__image">
                                <img
                                  src={
                                    post.image
                                      ? getImageUrl(post.image)
                                      : lower_back
                                  }
                                  alt={post.title}
                                  onError={(e) => {
                                    e.target.src = lower_back;
                                  }}
                                />
                              </div>
                              <div className="blog__card__content">
                                {post.category && (
                                  <span className="blog__card__category">
                                    {post.category}
                                  </span>
                                )}
                                <h4 className="blog__card__title">
                                  {post.title}
                                </h4>
                                {post.author && (
                                  <p className="blog__card__author">
                                    by {post.author}
                                  </p>
                                )}
                                <p className="blog__card__excerpt">
                                  {post.excerpt ||
                                    (post.content
                                      ? post.content.substring(0, 120) + "..."
                                      : "")}
                                </p>
                                <Link
                                  to={`/blog/${post._id}`}
                                  className="site__button site__button_style--solid site__button_shape--default"
                                >
                                  <span className="text">Read more</span>
                                </Link>
                              </div>
                            </div>
                          ))}
                        </Reveal>
                        <div className="blog__view-all">
                          <Link
                            to="/blog"
                            className="site__button site__button_style--solid site__button_shape--default site__button--large"
                          >
                            <span className="text">View All</span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

              </article>
            </main>
          </div>
        </div>
      </div>

      {/* ==================== Insurance Section ==================== */}
      {insurance && insurance.length > 0 && (
        <section
          id="comp_icon_slider_1"
          className="compSection compSection_9 comp_icon_slider comp_icon_slider_1 icon_slider textcolor__default"
          data-animate="1"
          style={{ backgroundColor: "#509fd7", zIndex: 1 }}
        >
          <span className="noise__shadow"></span>
          <Reveal as="div" direction="up" className="we-accept-title">We Accept</Reveal>
          <div className="insurance-marquee">
            <div className="insurance-marquee__track">
              {[...insurance, ...insurance].map((provider, index) => (
                <div key={index} className="insurance-marquee__item">
                  <img
                    src={provider.image ? getImageUrl(provider.image) : HICAPS}
                    alt={provider.name}
                    onError={(e) => { e.target.src = HICAPS; }}
                  />
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Home;
